import _memoize from 'lodash/memoize';
import { Lightning } from '@lightningjs/sdk';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, SECONDARY } from '@tornado-rdk/theme';
import { cacheResolver, makeDefaultStylingContext } from '../../../tornado/utils/style';
import { middle } from '../../../tornado/utils/sizes';
import { TRANSPARENT, WHITE } from '../../../tornado/utils/colors';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(SECONDARY),
};

export const DIAMETER = {
  [HD]: 168,
  [FULL_HD]: 168,
};

export const ICON_HEIGHT = {
  [HD]: 72,
  [FULL_HD]: 72,
};

export const getTexture = context => {
  const { screenSize } = context;
  const size = DIAMETER[screenSize];

  return Lightning.Tools.getRoundRect(size, size, Math.round(size / 2), 0, TRANSPARENT, true, WHITE);
};

export const getInitialStyle = _memoize((context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const size = DIAMETER[screenSize];
  const iconStyle = {
    mount: 0.5,
    x: middle,
    y: middle,
  };

  return {
    alpha: 0,
    w: size,
    h: size,
    Background: {
      color: colors.background[colorMode],
      texture: getTexture(context),
      w: size,
      h: size,
    },
    PlayIcon: iconStyle,
    PauseIcon: iconStyle,
  };
}, cacheResolver);
